module.exports = __webpack_public_path__ + "4235b67bbd8e4fb9b51138f1e81034fe.mp4";